<template>
  <svg
    :class="[size, color, rotate]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 8.34 13.64"
    xml:space="preserve"
  >
    <path
      class="st2"
      d="M1.351 13.093a.691.691 0 0 1-.49-1.18l5.15-5.14-5.03-5.03a.704.704 0 0 1 .02-.98c.27-.26.69-.26.96 0l5.52 5.52c.27.27.27.71 0 .98l-5.63 5.63a.72.72 0 0 1-.5.2"
    />
  </svg>
</template>

<script>
export default {
  name: "ArrowIcon",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["small", "medium", "large"].includes(value);
      },
    },
    color: {
      type: String,
      default: "grey",
      validator: function (value) {
        // The value must match one of these strings
        return ["grey", "primary", "secondary", "white"].includes(value);
      },
    },
    rotate: {
      default: "point-right",
      validator: function (value) {
        // The value must match one of these strings
        return ["point-right", "point-down", "point-left"].includes(value);
      },
    },
  },
};
</script>

<style scoped>
.small {
  width: 14px;
  height: 14px;
}
.medium {
  width: 24px;
  height: 24px;
}

.grey path {
  fill: #4a4a4a;
}
.white path {
  fill: white;
}

.primary path {
  fill: #619bc4;
}
.secondary path {
  fill: #d9835e;
}

.point-down {
  transform: rotate(90deg);
}

.point-left {
  transform: rotate(180deg);
}
</style>
